(function (angular) {
    'use strict';

    angular.module('phoneValidation')
        /**
         *
         */
        .controller('phoneValidationCtrl', ['$scope', '$stateParams', 'phoneValidationService', '$uibModal', 'growlService', 'countries', 'permissionService', '$state', function ($scope, $stateParams, phoneValidationService, $uibModal, growlService, countries, permissionService, $state){
            $scope.permission = permissionService.checkPermission("pnv:w");
            $scope.pickedApiSpaceId = $stateParams.pickedApiSpaceId;
            $scope.singleValidation = {};
            $scope.countries = countries;
            $scope.file = {
            };
            $scope.runBulkValidationModal = function(){
                $scope.bulkValidation = {
                    data: $scope.file.data
                };
                var modalInstance = $uibModal.open({
                    animation: true,
                    templateUrl: 'components/toolkit/phoneValidation/templates/phoneBulkValidationModal.html',
                    controller: 'phoneBulkValidationModalCtrl',
                    size: 'lg',
                    resolve: {
                        bulkValidation: function(){
                            return $scope.bulkValidation;
                        },
                        countries: function(){
                            return $scope.countries;
                        }
                    }
                  });

                modalInstance.result.then(function (data) {
                    $scope.bulkValidation = data;
                    $scope.bulkValidation.country = !$scope.bulkValidation.country ? undefined : $scope.bulkValidation.country;
                    $scope.bulkValidation.isInternational = !$scope.bulkValidation.isInternational ? false : true;
                    $scope.bulkValidation.firstRowHeader = $scope.bulkValidation.firstRowHeader ? true : false;
                    phoneValidationService.postBulkValidation($scope.bulkValidation.data, $scope.bulkValidation.separator, $scope.bulkValidation.country, $scope.bulkValidation.firstRowHeader, $scope.bulkValidation.mobilePhoneField, $scope.bulkValidation.isInternational ,$stateParams.pickedApiSpaceId).then(function(result){
                        growlService.success('File successfully sent to validation server');
                        phoneValidationService.startCheckingIfValidationComplete(result, $scope.pickedApiSpaceId);
                        $scope.bulkValidation = {};
                    }, function onError() {
                        growlService.danger('Error when sending the files to the validation server');
                    });
                }, function () {

                });
            };

            $scope.runSingleValidation = function(){
                phoneValidationService.getSingleValidation($scope.singleValidation.number, $scope.singleValidation.country, $scope.pickedApiSpaceId).then(function(response){
                    $scope.openSingleValidationModal(response);
                }).catch(function(){
                    growlService.danger('Cannot perform validation, please try again');
                });
            };
            $scope.openSingleValidationModal = function (singleValidation) {
                var modalInstance = $uibModal.open({
                    animation: true,
                    templateUrl: 'components/toolkit/phoneValidation/templates/phoneSingleValidationModal.html',
                    controller: 'phoneSingleValidationModalCtrl',
                    resolve: {
                        singleValidation: function(){
                            return singleValidation;
                        },
                        originalPhoneNumber: function(){
                            return $scope.singleValidation.number;
                        }
                    }
                  });

                modalInstance.result.then(function (data) {
                }, function () {

                });
            };
        }])

        .controller('phoneSingleValidationModalCtrl', [ "$scope", "$uibModalInstance", "singleValidation", "originalPhoneNumber", 
            function ($scope, $uibModalInstance, singleValidation, originalPhoneNumber) {
            $scope.singleValidation = singleValidation;
            $scope.originalPhoneNumber = originalPhoneNumber;
            $scope.close = function () {
                $uibModalInstance.dismiss('cancel');
            };

        }])

        .controller('phoneBulkValidationModalCtrl', [ "$scope", "$uibModalInstance", "bulkValidation", "countries",
            function ($scope, $uibModalInstance, bulkValidation, countries) {
            $scope.countries = countries;
            $scope.compareStringfyValues = function(one, two){
                return String(one).trim() == String(two).trim();
            };
            $scope.variablesChanged = false;
            $scope.bulkValidation = bulkValidation;
            $scope.startReading = function(){
                var reader = new FileReader();
                reader.onload = function(e) {
                    var contents = e.target.result;
                    $scope.$apply(function () {
                        $scope.afterReading(contents);
                    });
                };
                reader.readAsText($scope.bulkValidation.data);
            };
            $scope.startReading();
            $scope.afterReading = function(contents){
                $scope.fileReader = contents;
                $scope.bulkValidation.separator = 'comma';
                $scope.evaluate = function (){
                    $scope.sample = $scope.parseCSVintoJson($scope.fileReader, $scope.bulkValidation.separator, $scope.bulkValidation.firstRowHeader);
                };
                $scope.ok = function (){
                    $uibModalInstance.close($scope.bulkValidation);
                };
                $scope.close = function () {
                    $uibModalInstance.dismiss();
                };

            };
            $scope.$watch('bulkValidation.separator', function (newVal, oldVal) {
                if(newVal !== undefined && $scope.evaluate !== undefined){
                        $scope.evaluate();
                }
            }, true);
            $scope.$watch('bulkValidation.firstRowHeader', function (newVal, oldVal) {
                if(newVal !== undefined && $scope.evaluate !== undefined){
                        $scope.evaluate();
                }
            }, true);
            // $scope.getPosibleSeparator = function(csvString){
            //     var comma = (csvString.split(",").length - 1);
            //     var tab = (csvString.split("\t").length - 1);
            //     var semicolon = (csvString.split(";").length - 1);
            //     if (comma>tab && comma > semicolon){
            //         return 'comma';
            //     }
            //     else if(tab >comma && tab > semicolon){
            //         return 'tab';
            //     }
            //     else{
            //         return 'semicolon';
            //     }
            // };
            $scope.parseCSVintoJson = function(csvString, separator, containHeaders){
                if(separator == 'comma'){
                    separator = ',';
                }
                else if(separator == 'tab'){
                    separator = '\t';
                }
                else if(separator == 'semicolon'){
                    separator = ';';
                }
                var i = 0;
                var maxLength = 5;
                var parsed = {
                    header: [],
                    content: []
                };
                var headers = [];
                var lines = csvString.split(/[\r\n]+/g);
                if(lines[0].match(/\d+/g) === null && containHeaders === undefined){
                    containHeaders = true;
                    $scope.bulkValidation.firstRowHeader = true;
                }
                if(containHeaders){
                    headers=lines[0].split(separator);
                    parsed.header = headers;
                    i++;
                }
                else{
                    for(var a = 0; a<lines[0].split(separator).length; a++){
                        parsed.header.push(a+1);
                    }
                    maxLength--;
                }
                var length = (lines.length<maxLength) ? lines.length : maxLength;
                var phoneColumn = Array(lines[0].split(separator).length).fill(true);
                for(i;i<length;i++){
                    var obj = {};
                    var currentline=lines[i].split(separator);
                    for(var j=0;j<currentline.length;j++){
                        if(containHeaders){
                            obj[headers[j]] = currentline[j];
                        }
                        else{
                            obj[j+1] = currentline[j];
                        }
                        if(/^\d+$/.test(currentline[j]) && phoneColumn[j] && currentline[j].length>5){
                            phoneColumn[j] = true;
                        }
                        else{
                            phoneColumn[j] = false;
                        }
                    }

                    parsed.content.push(obj);
                }
                for(var x=0; x<phoneColumn.length; x++){
                    if(phoneColumn[x]){
                        $scope.bulkValidation.mobilePhoneField = String(parsed.header[x]);
                    }
                }
                return parsed;
            };

        }]);

})(window.angular);
